import { useNavigate } from 'react-router-dom';

export const useSafeNavigate = () => {
  try {
    return useNavigate();
  } catch (error) {
    // Not in Router context, return a fallback function
    return (path: string, options?: any) => {
      if (options?.replace) {
        window.location.replace(path);
      } else {
        window.location.href = path;
      }
    };
  }
};
